import { render, staticRenderFns } from "./userAccessRight.vue?vue&type=template&id=6de50cda&scoped=true"
import script from "./userAccessRight.vue?vue&type=script&lang=js"
export * from "./userAccessRight.vue?vue&type=script&lang=js"
import style0 from "./userAccessRight.vue?vue&type=style&index=0&id=6de50cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de50cda",
  null
  
)

export default component.exports